export function voiceFromConfig(config, fallbackVoice) {
    const voice = config?.data?.platform?.help_agent_voice;
    return typeof voice === 'string' && voice.trim() ? voice.trim() : fallbackVoice;
}

/** Resolve the Help voice once. Every caller in this browser session shares it. */
export function createSessionVoiceResolver(loadConfig, fallbackVoice, timeoutMs = 1500, onError = () => {}) {
    let resolution = null;

    return {
        resolve() {
            if (!resolution) {
                resolution = new Promise(resolve => {
                    let settled = false;
                    const finish = voice => {
                        if (settled) return;
                        settled = true;
                        clearTimeout(timer);
                        resolve(voice);
                    };
                    const fail = error => {
                        if (settled) return;
                        try { onError(error); } catch (_) { /* diagnostics must not block fallback */ }
                        finish(fallbackVoice);
                    };
                    const timer = setTimeout(
                        () => fail(new Error('Help voice preference resolution timed out')),
                        timeoutMs,
                    );
                    Promise.resolve()
                        .then(loadConfig)
                        .then(async response => {
                            if (!response?.ok) throw new Error('Help voice preference request failed');
                            return response.json();
                        })
                        .then(config => finish(voiceFromConfig(config, fallbackVoice)))
                        .catch(fail);
                });
            }
            return resolution;
        },
    };
}
